import EditEndDateModalView from './EditEndDateModalView';
const meta = {
    title: 'Features/InspectionSeries/EditEndDateModal',
    component: EditEndDateModalView,
    args: {
        isOpen: true,
        endDate: new Date('2027-03-31T00:00:00'),
        originalEndDate: new Date('2027-06-30T00:00:00'),
        minEndDate: new Date('2026-09-16T00:00:00'),
        maxEndDate: new Date('2036-09-15T00:00:00'),
        isSaving: false,
        countState: { status: 'ready', count: 0 },
        onEndDateChange: () => undefined,
        onSave: () => undefined,
        onClose: () => undefined
    }
};
export default meta;
/** Date moved earlier, but nothing falls beyond it. */
export const NothingCancelled = {};
/** Untouched date: no notice at all, and Save is disabled. */
export const Unchanged = {
    args: { endDate: new Date('2027-06-30T00:00:00') }
};
/** Moved later. Extending only creates work, so there is no notice and Save stays enabled. */
export const MovedLater = {
    args: { endDate: new Date('2027-12-31T00:00:00'), countState: { status: 'idle' } }
};
/** The date has been moved earlier and the preview has returned a count. */
export const CancelsFutureInspections = {
    args: { countState: { status: 'ready', count: 12 } }
};
/** Exactly one inspection affected — checks the singular form of the warning. */
export const CancelsOne = {
    args: { countState: { status: 'ready', count: 1 } }
};
/** Waiting on the debounced preview request. Save is held until the count is known. */
export const LoadingCount = {
    args: { countState: { status: 'loading' } }
};
/** The preview request failed. Save is disabled rather than showing a misleading zero. */
export const CountUnavailable = {
    args: { countState: { status: 'unavailable' } }
};
/** Save in flight. */
export const Saving = {
    args: { isSaving: true, countState: { status: 'ready', count: 12 } }
};
